import { MenuListItem } from '@/shared/components/export';
import { WidgetMenuEntry } from '@/core/widgets/model/news-widget-factory';

export interface WidgetMenuEntryToItemOptions {
  onSelect: (url: string) => void;
  isChecked?: (url: string) => boolean;
  isFavorite?: (url: string) => boolean;
  onToggleFavorite?: (url: string) => void;
}

/** Converts a NewsWidgetFactory's getListableUrls() tree into MenuListItem[] (leaves selectable, groups collapsible), recursing with `${key}-${index}` child keys. */
export function widgetMenuEntryToItem(
  entry: WidgetMenuEntry,
  key: string,
  options: WidgetMenuEntryToItemOptions,
): MenuListItem {
  if (entry.url !== undefined) {
    const url = entry.url;
    return {
      key,
      label: entry.name,
      onSelect: () => options.onSelect(url),
      checked: options.isChecked?.(url),
      favorite: options.isFavorite?.(url),
      onToggleFavorite: options.onToggleFavorite ? () => options.onToggleFavorite!(url) : undefined,
    };
  }

  return {
    key,
    label: entry.name,
    collapsible: entry.children.map((child, index) =>
      widgetMenuEntryToItem(child, `${key}-${index}`, options),
    ),
  };
}
